export default __webpack_public_path__ + "static/media/Sass-Logo.8351205a.svg";